type FontWeight = 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900

const definition: Record<string, FontWeight> = {
    regular: 400,
    semiBold: 600,
    bold: 700,
} satisfies Record<string, FontWeight>

export const fontWeights: { [K in keyof typeof definition]: FontWeight } = definition
